import { render } from "./CustomerTypes.vue?vue&type=template&id=175eb49a"
import script from "./CustomerTypes.vue?vue&type=script&lang=js"
export * from "./CustomerTypes.vue?vue&type=script&lang=js"
script.render = render

export default script